module.exports = __webpack_public_path__ + "media/images/slide-5-b81d46197f038ea1cf7b61d3e6e98241.png";